NftUpgrade.Nft = daz.Nft
NftUpgrade.nullNft = new NftUpgrade.Nft();
Object.freeze(NftUpgrade.nullNft);
